import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { checkValidity, closeDrawer, getURLSegment  } from '../../helpers/helpers.js'

const EditVoucher = observer(class EditVoucher extends React.Component {
  constructor() {
    super();
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
  }

  componentWillMount() {
    this.state = {
      voucherData: {
        tag: null,
        memo: null
      }
    }

    this.getVoucher();
  }

  getVoucher() {
    this.props.store.VoucherStore.getVoucher(this.props.voucherSid);
  }

  handleInput() {
    let voucherData = { ...this.state.voucherData };

    voucherData.tag = this.tag.value || '';
    voucherData.memo = this.memo.value || '';

    this.setState({
      voucherData
    })
  }

  handleSubmit(e) {
    let payload = {};

    Object.keys(this.state.voucherData).forEach( prop => {
      if(this.state.voucherData[prop]) payload[prop] = this.state.voucherData[prop];
    });

    this.props.store.VoucherStore.updateVoucher(this.props.voucherSid, payload, this.complete);
  }

  complete() {
    closeDrawer(null, this.props.parent, getURLSegment(this, 1));

    this.props.store.SessionStore.showToaster(this.props.translation.voucher_saved, 'success');
  }

  render() {
    const { translation } = this.props;
    const { voucherData } = this.props.store.VoucherStore;

    if(Object.keys(voucherData).length > 0) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.page_title}</h1>
            </div>
          </header>

          <div className="wrap block-form">
            <form onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
              <div className="panel--medium">
                <fieldset>
                  <ul className="fields">
                    {/*<li className="field--auto">
                      <label className="lbl-required" htmlFor="vouchers-amount">{translation.amount.label}</label>
                      <input type="number" id="vouchers-amount" placeholder="0" required aria-required="true" />
                      <label className="select">
                        <select>
                          {SessionStore.currencyList.map(
                            (key, i) =>
                            <option key={i} value={key.code}>{key.name}</option>
                          )}
                        </select>
                      </label>
                    </li>
                    <li>
                      <label className="lbl-optional" htmlFor="vouchers-number">{translation.number.label}</label>
                      <input type="number" min="1" id="vouchers-number" placeholder="0" />
                    </li>*/}
                    <li>
                      <label className="lbl-optional" htmlFor="vouchers-tag" aria-describedby="vouchers-tag-tooltip">
                        {translation.tag.label}

                        <div className="tooltip">
                          <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                          <div id="vouchers-tag-tooltip" className="tooltip__body" role="tooltip">{translation.tag.tooltip}</div>
                        </div>
                      </label>

                      <input
                        type="text"
                        id="vouchers-tag"
                        ref={(input) => { this.tag = input }}
                        onChange={this.handleInput}
                        defaultValue={voucherData.tag}
                      />
                    </li>
                    <li>
                      <label className="lbl-optional" htmlFor="vouchers-memo" aria-describedby="vouchers-memo-tooltip">
                        {translation.memo.label}

                        <div className="tooltip">
                          <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                          <div id="vouchers-memo-tooltip" className="tooltip__body" role="tooltip">{translation.memo.tooltip}</div>
                        </div>
                      </label>

                      <input
                        type="text"
                        id="vouchers-memo"
                        ref={(input) => { this.memo = input }}
                        onChange={this.handleInput}
                        defaultValue={voucherData.memo}
                      />
                    </li>
                    {/*{this.props.single &&
                      <li>
                        <label className="lbl-optional" htmlFor="vouchers-notransfer" aria-describedby="vouchers-notransfer-tooltip">
                          {translation.non_transferable.label}

                          <div className="tooltip">
                            <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                            <div id="vouchers-notransfer-tooltip" className="tooltip__body" role="tooltip">{translation.non_transferable.tooltip}</div>
                          </div>
                        </label>
                        <input type="checkbox" id="vouchers-notransfer" className="switch-input" value="1" />
                        <label className="switch-label" htmlFor="vouchers-notransfer"><span className="meta">{translation.non_transferable.label}</span></label>
                      </li>
                    }*/}
                  </ul>

                  <div className="panel__actions actions">
                    <button className="actions__btn actions__btn--primary">{translation.button}</button>
                  </div>
                </fieldset>
              </div>
            </form>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('EditVoucher')(EditVoucher);


// WEBPACK FOOTER //
// ./src/app/components/Vouchers/EditVoucher.js